/**
 * Renders Strapi rich text (Lexical/block format) to React elements.
 * Supports: paragraph, heading, list, list-item, link, and inline marks (bold, italic, underline, strikethrough, code).
 */

const renderTextNode = (node, index) => {
  let content = node.text;
  if (!content && content !== "") return null;

  if (node.bold) content = <strong key={index}>{content}</strong>;
  if (node.italic) content = <em key={index}>{content}</em>;
  if (node.underline) content = <u key={index}>{content}</u>;
  if (node.strikethrough) content = <s key={index}>{content}</s>;
  if (node.code) content = <code key={index}>{content}</code>;

  return <span key={index}>{content}</span>;
};

const renderChildren = (children) =>
  children?.map((child, i) => {
    if (child.type === "text") return renderTextNode(child, i);
    if (child.type === "link")
      return (
        <a key={i} href={child.url} target="_blank" rel="noopener noreferrer">
          {renderChildren(child.children)}
        </a>
      );
    return null;
  });

const renderBlock = (block, index) => {
  switch (block.type) {
    case "paragraph":
      return <p key={index}>{renderChildren(block.children)}</p>;

    case "heading": {
      const Tag = `h${block.level || 2}`;
      return <Tag key={index}>{renderChildren(block.children)}</Tag>;
    }

    case "list": {
      const ListTag = block.format === "ordered" ? "ol" : "ul";
      return (
        <ListTag key={index}>
          {block.children?.map((item, i) => (
            <li key={i}>{renderChildren(item.children)}</li>
          ))}
        </ListTag>
      );
    }

    case "quote":
      return <blockquote key={index}>{renderChildren(block.children)}</blockquote>;

    default:
      return null;
  }
};

const StrapiRichText = ({ content }) => {
  if (!content || !Array.isArray(content)) return null;
  return <>{content.map((block, i) => renderBlock(block, i))}</>;
};

export default StrapiRichText;
